import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ContentCopyIcon from '@mui/icons-material/ContentCopyRounded';
import { Button, IconButton, Stack, Typography } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { TelegramIcon, TwitterXIcon } from '../../../../components/footer/social_icons.tsx';
import { useReferralCardData, useReferralLinkCopy, useReferralShare } from '../../hooks/useReferralCardData.ts';

interface ReferralsMiniCardProps {
  onLinkClick?: () => void;
}

const iconButtonSx = {
  border: '1px solid',
  borderColor: 'var(--mui-palette-_components-input-outlined-enabledBorder)',
  color: 'text.primary',
  width: 40,
  height: 40,
};

export function ReferralsMiniCard({ onLinkClick }: ReferralsMiniCardProps) {
  const { referralLink, refCode, shouldDisplayData } = useReferralCardData();
  const { handleCopy, isCopyDisabled } = useReferralLinkCopy(referralLink);

  const hasReferral = shouldDisplayData && Boolean(referralLink);
  const remainingInvites = Math.max((refCode?.limit ?? 0) - (refCode?.used ?? 0), 0);
  const actionsDisabled = !hasReferral || remainingInvites === 0;

  const { handleShareTelegram, handleShareTwitter } = useReferralShare(referralLink, actionsDisabled);

  if (!hasReferral) return null;

  return (
    <Stack spacing={2} px={2}>
      <Typography variant="h6">Share referral code</Typography>
      <Stack direction="row" spacing={2}>
        <IconButton
          sx={iconButtonSx}
          onClick={handleCopy}
          disabled={isCopyDisabled || actionsDisabled}
          aria-label="Copy referral link"
        >
          <ContentCopyIcon />
        </IconButton>
        <IconButton sx={iconButtonSx} onClick={handleShareTelegram} disabled={actionsDisabled} aria-label="Share on Telegram">
          <TelegramIcon />
        </IconButton>
        <IconButton sx={iconButtonSx} onClick={handleShareTwitter} disabled={actionsDisabled} aria-label="Share on X">
          <TwitterXIcon />
        </IconButton>
      </Stack>
      <Button
        component={Link}
        to="/leaderboard"
        variant="text"
        size="small"
        endIcon={<ArrowForwardIcon />}
        onClick={onLinkClick}
        sx={{ alignSelf: 'flex-start', px: 1, height: 32 }}
      >
        Referral stats on Leaderboard
      </Button>
    </Stack>
  );
}
